<div class="modal-container">
  <!-- Sticky Header -->
  <div class="modal-header">
    <h2>Bot "{{ data.bot.name }}" configuration history</h2>
  </div>

  <!-- Content Area -->
  <div class="modal-content">
    @if (isLoading) { <app-spinner></app-spinner> }
    @else {
      @if (history.length > 0) {
        <mat-accordion>
          @for (item of history; track item) {
            <mat-expansion-panel hideToggle>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="d-flex align-items-center justify-content-between title">
                    <p>{{ item.versionCreatedAt | dateFromNow }}</p>
                    <p>{{ item.versionCreatedAt | date: 'yyyy-MM-dd, HH:mm' }}</p>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <app-bot-config-comparison [current]="data.bot" [fieldSet]="data.fieldSet" [version]="item" (revert)="revertVersion($event)" (delete)="deleteVersion($event)"></app-bot-config-comparison>
            </mat-expansion-panel>
          }
        </mat-accordion>
      }
      @else { <p class="no-content">The history is empty</p> }
    }
  </div>

  <!-- Bottom Sheet -->
  <div class="modal-footer">
    <button mat-raised-button color="accent" (click)="close()">Close</button>
  </div>
</div>
